import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from "react-toastify";

const EditProjectForm = ({ closeModal, caseData, onProjectUpdated }) => {
  const [formData, setFormData] = useState(caseData);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchClients = async () => {
      const token = localStorage.getItem("token");

      try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/client`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        });
        setClients(res.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching clients", err);
        setLoading(false);
      }
    };

    if (caseData) {
      setFormData(caseData);
    }

    fetchClients();
  }, [caseData]);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    try {
      await axios.put(`${process.env.REACT_APP_BACKEND_URL}/api/Projects/${formData._id}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });

      toast.success("Project updated successfully!");
       
    // 🔑 THIS IS THE KEY CHANGE
    if (onProjectUpdated) {
        onProjectUpdated();
    }
      closeModal();
    } catch (error) {
      console.error("Error updating project:", error);
      toast.error("Failed to update project.");
    }
  };

  if (loading || !formData) return <div>Loading...</div>;

  return (
    <div>
      <form
        onSubmit={handleSubmit}
        className="space-y-4 max-h-[80vh] overflow-y-auto p-4 bg-white rounded-lg shadow-lg"
      >
        <h2 className="text-2xl font-bold mb-4">Edit Project</h2>

        {/* Project Title & Client */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Project Title</label>
            <input
              type="text"
              name="caseTitle"
              value={formData.caseTitle}
              onChange={handleChange}
              className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Client</label>
            <select
              name="client"
              value={formData.client}
              onChange={handleChange}
              className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            >
              <option value="">Select a Client</option>
              {clients.map((client) => (
                <option key={client._id} value={client._id}>
                  {client.clientName}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Project Number</label>
            <input
              type="number"
              name="caseNumber"
              value={formData.caseNumber}
              onChange={handleChange}
              className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Project Type</label>
            <select
              name="caseType"
              value={formData.caseType}
              onChange={handleChange}
              className="w-full border rounded px-3 py-2"
              required
            >
              <option value="">Select Project Type</option>
              <option value="E-commerce">E-commerce</option>
              <option value="Portofolio">Portofolio</option>
              <option value="Bussiness site">Bussiness site</option>
            </select>
          </div>
        </div>

        {/* Project Year */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Project Year</label>
            <select
              name="caseYear"
              value={formData.caseYear}
              onChange={handleChange}
              className="w-full border rounded px-3 py-2"
              required
            >
              <option value="">Select Year</option>
              {[...Array(20)].map((_, i) => {
                const year = new Date().getFullYear() - i;
                return (
                  <option key={year} value={year}>
                    {year}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        {/* Start Date */}
        <div>
          <label className="block text-sm font-medium mb-1">Start Date</label>
          <input
            type="date"
            name="StartDate"
            value={formData.StartDate}
            onChange={handleChange}
            className="w-full border rounded px-3 py-2"
          />
        </div>

        {/* Contact Section */}
        <div className="border rounded p-4 space-y-4 bg-gray-50">
          <h4 className="text-lg font-semibold">Contact</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">Contact Email</label>
              <input
                type="email"
                name="contactEmail"
                value={formData.contactEmail}
                onChange={handleChange}
                className="w-full border rounded px-3 py-2"
                required
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Contact Phone</label>
              <input
                type="tel"
                name="contactPhone"
                value={formData.contactPhone}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,10}$/.test(value)) {
                    handleChange(e);
                  }
                }}
                maxLength={10}
                pattern="\d{10}"
                inputMode="numeric"
                placeholder="Enter 10-digit mobile number"
                className="w-full border rounded px-3 py-2"
                required
              />
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="flex justify-between mt-4">
          <button
            type="submit"
            className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
          >
            Save Changes
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="bg-gray-400 text-white px-4 py-2 rounded hover:bg-gray-500"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditProjectForm;
